import { Meal, OrderHistoryReceiptMeal } from '@tovala/browser-apis-combinedapi'
import { ReactNode } from 'react'

import DetailsDialog from './DetailsDialog'
import { MealDetails } from './MealDetails'
import { CookTime, ExpirationDate } from './shared'
import { DialogTitle } from '@headlessui/react'

const MealDetailsDialog = ({
  averageRating,
  closeModal,
  imageTag,
  meal,
  orderStatus,
  price,
  reviews,
  stepper,
}: {
  averageRating?: ReactNode
  closeModal(): void
  imageTag?: ReactNode
  meal: Meal | OrderHistoryReceiptMeal
  orderStatus?: ReactNode
  price?: ReactNode
  reviews?: ReactNode
  stepper?: ReactNode
}) => {
  return (
    <DetailsDialog onClose={closeModal}>
      <div className="flex-auto overflow-y-auto">
        <MealDetails
          averageRating={averageRating}
          cookTime={
            <CookTime
              mealID={meal.id}
              routineMetadataObjects={meal.routineMetadataObjects}
            />
          }
          expirationDate={
            <ExpirationDate expirationDate={meal.expirationDate} />
          }
          imageTag={imageTag}
          meal={meal}
          price={price}
          reviews={reviews}
          stepper={stepper}
          title={<DialogTitle>{meal.title}</DialogTitle>}
        />
      </div>

      {orderStatus}
    </DetailsDialog>
  )
}

export default MealDetailsDialog
